<template>
  <div class="backdrop" :class="showMenuMobile" @click="clickOutMenuMobile">
    <aside :class="showMenuMobile">
      <img src="@/assets/icons/arrow-left.svg" class="arrow-left" />

      <nav>
        <router-link to="/teacher" class="center" @click="toggleMenuMobile">
          <div class="header">
            <TheAvatar
              :img="require('@/assets/avatar/avatar-profile.svg')"
              max-width="106px"
            />

            <p class="nome">
              {{ `${users.firstName} ${users.lastName}` }}
            </p>

            <p class="profissao">
              {{ resume.title }}
            </p>
          </div>
        </router-link>

        <ul class="menu-itens">
          <li>
            <img src="@/assets/icons/menu/edit.svg" />
            <p>Editar página</p>
          </li>

          <router-link v-if="isTeacher" to="/teacher/courses">
            <li @click="closeMenuMobile">
              <img src="@/assets/icons/menu/device-monitor.svg" />
              <p>Meus cursos</p>
            </li>
          </router-link>

          <router-link to="/teacher/financial">
            <li>
              <img src="@/assets/icons/menu/file-folder.svg" />
              <p>Painel Financeiro</p>
            </li>
          </router-link>

          <router-link to="/teacher/metrics">
            <li>
              <img src="@/assets/icons/menu/metrics.svg" />
              <p>Métricas</p>
            </li>
          </router-link>

          <router-link to="/teacher/notifications">
            <li>
              <img src="@/assets/icons/menu/notification.svg" />
              <p>Notificações</p>
            </li>
          </router-link>

          <router-link to="/teacher/settings">
            <li>
              <img src="@/assets/icons/menu/settings.svg" />
              <p>Configurações</p>
            </li>
          </router-link>

          <router-link to="/teacher/support">
            <li>
              <img src="@/assets/icons/menu/help.svg" />
              <p>Suporte</p>
            </li>
          </router-link>

          <router-link v-if="isAdmin" to="/admin">
            <li>
              <i class="el-icon-data-line"> </i>
              <p style="color: #e6a23c">Admin</p>
            </li>
          </router-link>
          <router-link to="/teste">
            <li>
              <i class="el-icon-data-line"> </i>
              <p style="color: #e6a23c">Recursos</p>
            </li>
          </router-link>
        </ul>
      </nav>
    </aside>
  </div>
</template>

<script>
import TheAvatar from '@/views/layout/avatar';
import { bus } from '@/main';
import { mapGetters } from 'vuex';
import axios from 'axios';

export default {
  name: 'TheSideBar',
  components: {
    TheAvatar,
  },
  data() {
    return {
      showMenu: false,
      users: [],
      isAdmin: false,
      isTeacher: false,
    };
  },
  emits: ['toogleMenuFromClick'],
  computed: {
    ...mapGetters('auth', ['resume']),

    showMenuMobile() {
      return { active: this.showMenu };
    },
  },
  watch: {
    $route() {
      this.showMenu = !this.showMenu;
    },
  },
  async created() {
    bus.$on('toggleMenu', this.toggleMenuMobile);

    await this.fetchUsers();
    await this.isAdminToggle();
    await this.isTeacherToggle();

    console.log(this.users);
  },
  methods: {
    clickOutMenuMobile(event) {
      if (event.target === event.currentTarget) this.showMenu = !this.showMenu;
    },
    toggleMenuMobile() {
      this.showMenu = !this.showMenu;
    },
    closeMenuMobile() {
      console.log('RouterLink');
      bus.$emit('toggleMenuFromClick');
    },
    async fetchUsers() {
      const id = localStorage.getItem('user');
      const token = localStorage.getItem('token');
      const { data } = await axios.get(
        `${process.env.VUE_APP_API}/user/${id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      this.users = data;
    },
    isAdminToggle() {
      const role = this.users.role;
      if (role === 'admin') {
        return (this.isAdmin = true);
      } else {
        return (this.isAdmin = false);
      }
    },
    isTeacherToggle() {
      const role = this.users.role;
      if (role === 'teacher') {
        return (this.isTeacher = true);
      } else {
        return (this.isTeacher = false);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* ASIDE */
aside {
  background: #fff;
  width: 100%;
  max-width: 270px;
  height: 100%;
  position: relative;

  .arrow-left {
    display: none;
  }

  .header {
    text-align: center;
    margin-top: 27px;

    .nome {
      font-size: 1.25rem;
      font-weight: 400;
      line-height: 20px;
      letter-spacing: 1px;
      color: #3a3b3f;
      margin-top: 7px;
      margin-bottom: 6px;
    }

    .profissao {
      font-size: 1rem;
      color: #9ea0a5;
      line-height: 16px;
    }
  }

  .menu-itens {
    list-style: none;
    padding: 30px 0;

    li {
      display: flex;
      color: #66788a;
      font-weight: 500;
      font-size: 1.12rem;
      line-height: 20px;
      padding: 10px 30px;
      cursor: pointer;

      img {
        margin-right: 10px;
      }
      i {
        font-size: 1.25rem;
        font-weight: 800;
        color: #e6a23c;
        margin-right: 20px;
      }

      p {
        margin-right: 10px;
        display: flex;
        align-items: center;
      }
    }

    a:hover {
      background: #f6f9fd;
    }
  }
}
.center {
  justify-content: center;
}

.menu-itens {
  a {
    &.router-link-exact-active {
      background: rgba(246, 249, 253, 1);
      color: rgba(46, 58, 89, 1);
      font-family: 'Roboto 500', sans-serif;
    }
  }
}

@media (max-width: 768px) {
  .backdrop {
    position: fixed;
    width: 100%;
    z-index: 10;
    height: 100vh;
    background: rgba(0, 0, 0, 0.5);
    top: 0;
    left: 0;
    display: none;

    &.active {
      display: block;
    }

    aside {
      display: none;
      position: fixed;
      z-index: 1000;
      height: 100vh;

      .arrow-left {
        display: block;
        position: absolute;
        top: 8px;
        right: 10px;
        cursor: pointer;
      }

      &.active {
        display: block;
      }
    }
  }
}
</style>
